export const stations = [
    "St. George's Cross",
    "Cowcaddens",
    "Buchanan Street",
    "St. Enoch",
    "Bridge Street",
    "West Street",
    "Shields Road",
    "Kinning Park",
    "Cessnock",
    "Ibrox",
    "Govan",
    "Partick",
    "Kelvinhall",
    "Hillhead",
    "Kelvinbridge"
]